export enum Feature {
  COMMENT_DRAFT = 'COMMENT_DRAFT',
}
